<div class="multi-select-dropdown">
  <div class="multi-select-dropdown__top-section">
    <pp-search-box
      [ppPlaceholder]="placeholderText | ppTranslate"
      (ppAction)="setKeyword($event)"
      ppSize="wide"
      class="multi-select-dropdown__search"
    />

    <div class="multi-select-dropdown__top-section__button-container">
      <p class="multi-select-dropdown__title">{{ parentTitle | ppTranslate }}</p>

      <div class="multi-select-dropdown__top-section__buttons">
        @if (isAllSelected && parentOptions.length > 0) {
          <button (click)="handleBulkSelection(false)">
            {{ 'deselect_all' | ppTranslate }}
          </button>
        } @else {
          <button [disabled]="parentOptions.length === 0" (click)="handleBulkSelection(true)">
            {{ 'select_all' | ppTranslate }}
          </button>
        }

        @if (isAllCollapsed) {
          <button (click)="handleBulkCollapse(false)">{{ 'expand_all' | ppTranslate }}</button>
        } @else {
          <button [disabled]="parentOptions.length === 0" (click)="handleBulkCollapse(true)">
            {{ 'collapse_all' | ppTranslate }}
          </button>
        }
      </div>
    </div>
  </div>

  <section class="multi-select-dropdown__parent">
    @if (parentOptions.length === 0) {
      <p class="multi-select-dropdown__parent--no-options">
        {{ 'no_accounts_sites_found' | ppTranslate }}
      </p>
    }
    @for (parent of parentOptions; track parent.id) {
      @if (parent.isVisible) {
        <div class="multi-select-dropdown__parent__item">
          <pp-checkbox
            ppType="solid"
            ppSize="medium"
            [ppChecked]="parent.isSelected"
            [ppHalfChecked]="parent.isIndeterminate"
            (ppOnValueChange)="toggleParentOption(parent.id)"
          />

          <div
            class="multi-select-dropdown__parent__item"
            (click)="handleExpandParentOptions(parent.id)"
          >
            <pp-icon
              [ppSrc]="
                parent.isCollapsed
                  ? EIconPath.ICON_CHEVRON_RIGHT
                  : EIconPath.ICON_MISC_DOWN_ARROW_18
              "
              ppColor="grey-600"
            />

            <p>{{ parent.label }}</p>
          </div>
        </div>

        @if (!parent.isCollapsed) {
          @for (child of parent.children; track child.id) {
            @if (child.isVisible) {
              <pp-checkbox
                class="multi-select-dropdown__child__item"
                ppType="solid"
                ppSize="medium"
                [ppChecked]="child.isSelected"
                (ppOnValueChange)="toggleChildOption(child.id, parent.id)"
              >
                {{ child.label }}
              </pp-checkbox>
            }
          }
        }
      }
    }
  </section>
  <div class="multi-select-dropdown__footer">
    <pp-button id="multiSelectCancelBtn" (click)="handleBulkSelection(false)">
      {{ 'clear_all' | ppTranslate }}
    </pp-button>

    <pp-button ppStyle="primary" ppSize="large" (ppAction)="handleSaveSelected()">
      {{ 'done' | ppTranslate }}
    </pp-button>
  </div>
</div>
